(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wss-drawer"]) return;
  try {
    
(() => {
  const drawer = document.getElementById('revene-cart-drawer');
  if (!drawer || drawer.dataset.bound) return;
  drawer.dataset.bound = 'true';
  let busy = false;
  let returnFocus;
  let oldOverflow = '';
  let previewDeadline;
  const track = name => {
    try {
      if (typeof window.clarity === 'function') window.clarity('event', name);
    } catch (_) {}
  };
  const open = () => {
    if (drawer.open) return;
    returnFocus = document.activeElement;
    oldOverflow = document.body.style.overflow;
    drawer.showModal();
    document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-rv-drawer-content]').scrollTop = 0;
    updateTimers();
  };
  drawer.addEventListener('close', () => {
    document.body.style.overflow = oldOverflow;
    if (returnFocus?.isConnected) returnFocus.focus();
  });
  const error = message => {
    drawer.querySelector('[data-rv-error]').textContent = message || '';
    const pageError = document.querySelector('[data-rv-page-error]');
    if (pageError) pageError.textContent = message || '';
  };
  const updateTimers = () => {
    const previews = document.querySelectorAll('[data-rv-demo]');
    if (previews.length && (drawer.open || document.querySelector('[data-rv-page-content]'))) {
      if (!previewDeadline) previewDeadline = Date.now() + 180000;
      const seconds = Math.max(0, Math.ceil((previewDeadline - Date.now()) / 1000));
      const value = [Math.floor(seconds / 60), seconds % 60].map(n => String(n).padStart(2, '0')).join(':');
      previews.forEach(el => { el.querySelector('[data-rv-clock]').textContent = value; });
    }
    document.querySelectorAll('[data-rv-deadline]').forEach(el => {
      const remaining = Date.parse(el.dataset.rvDeadline) - Date.now();
      el.hidden = !Number.isFinite(remaining) || remaining <= 0;
      if (el.hidden) return;
      const seconds = Math.floor(remaining / 1000);
      const hours = Math.floor(seconds / 3600);
      const mins = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      el.querySelector('[data-rv-clock]').textContent = [hours, mins, secs].map(n => String(n).padStart(2, '0')).join(':');
    });
  };

  const queue = [];
  const pendingQuantities = new Map();
  const sectionData = () => ({sections:drawer.dataset.sectionId, sections_url:drawer.dataset.cartUrl});
  const setControls = () => {
    document.querySelectorAll('[data-rv-step]').forEach(el => { el.disabled = false; });
    document.querySelectorAll('[data-rv-quantity]').forEach(input => {
      const removing = pendingQuantities.get(input.dataset.key) === 0;
      input.disabled = removing;
      input.parentElement.querySelectorAll('[data-rv-step]').forEach(button => { button.disabled = removing; });
    });
    document.querySelectorAll('[data-rv-upgrade], button[name="checkout"]').forEach(el => { el.disabled = busy; });
    drawer.toggleAttribute('aria-busy', busy);
    if (busy) drawer.setAttribute('aria-busy', 'true');
    const page = document.querySelector('[data-rv-page-content]');
    if (page) {
      if (busy) page.setAttribute('aria-busy', 'true'); else page.removeAttribute('aria-busy');
    }
  };
  const render = html => {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const content = parsed.querySelector('[data-rv-content]');
    if (!content) throw new Error(drawer.dataset.error);
    const active = document.activeElement;
    const activeLine = active?.closest('.rvc-line');
    const focusKey = activeLine?.querySelector('[data-rv-quantity]')?.dataset.key;
    const focusZone = active?.closest('[data-rv-page-content]') ? 'page' : 'drawer';
    const focusStep = active?.dataset.rvStep;
    const focusRemove = active?.matches('[data-rv-remove]');
    drawer.querySelector('[data-rv-drawer-content]').replaceChildren(content.cloneNode(true));
    const page = document.querySelector('[data-rv-page-content]');
    if (page) {
      const clone = content.cloneNode(true);
      clone.querySelectorAll('[id], [for], [form]').forEach(el => {
        ['id', 'for', 'form'].forEach(attr => {
          if (el.hasAttribute(attr)) el.setAttribute(attr, el.getAttribute(attr).replace('drawer-', 'page-'));
        });
      });
      page.replaceChildren(clone);
    }
    document.querySelectorAll('[data-rv-quantity]').forEach(input => {
      if (pendingQuantities.has(input.dataset.key)) input.value = pendingQuantities.get(input.dataset.key);
    });
    document.querySelectorAll('.wss-hd__cart b').forEach(el => { el.textContent = content.dataset.count; });
    setControls();
    if (focusKey && active && !active.isConnected) {
      const scope = focusZone === 'page' ? page : drawer;
      const input = Array.from(scope?.querySelectorAll('[data-rv-quantity]') || []).find(el => el.dataset.key === focusKey);
      const target = focusStep ? input?.parentElement.querySelector('[data-rv-step="' + focusStep + '"]') : focusRemove ? input?.closest('.rvc-line').querySelector('[data-rv-remove]') : input;
      if (target) target.focus({preventScroll:true});
      else if (scope) {
        scope.setAttribute('tabindex', '-1');
        scope.focus({preventScroll:true});
      }
    }
    updateTimers();
  };
  const refresh = async () => {
    const url = new URL(drawer.dataset.cartUrl, location.origin);
    url.searchParams.set('section_id', drawer.dataset.sectionId);
    const response = await fetch(url, {credentials:'same-origin', cache:'no-store'});
    if (!response.ok) throw new Error(drawer.dataset.error);
    render(await response.text());
  };
  const getJSON = async url => {
    const response = await fetch(url, {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error(drawer.dataset.error);
    return response.json();
  };
  const post = async (url, body) => {
    const json = !(body instanceof FormData);
    const response = await fetch(url + '.js', {
      method:'POST',
      credentials:'same-origin',
      headers:json ? {Accept:'application/json', 'Content-Type':'application/json'} : {Accept:'application/json'},
      body:json ? JSON.stringify(body) : body
    });
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(drawer.dataset.error);
    return result;
  };

  /* Free gifts: the Pair and Court Kit include insoles (the Kit adds the elbow strap). They are added to the cart
     as their own lines, tagged with a `_gift` property, so the order carries a real SKU for CJ to ship. A Buy-X-Get-Y
     automatic discount makes them free. Gift lines are hidden in the cart UI (they show as pack components). */
  const isGift = item => !!(item.properties && item.properties._gift);
  let giftRules = [];
  try { giftRules = JSON.parse(drawer.dataset.giftRules || '[]'); } catch (_) {}
  const syncGifts = async cart => {
    if (!giftRules.length) return false;
    if (!cart) cart = await getJSON(drawer.dataset.cartUrl + '.js');
    let changed = false;
    for (const rule of giftRules) {
      const need = cart.items.filter(item => rule.triggers.includes(item.variant_id)).reduce((n, item) => n + item.quantity, 0);
      const lines = cart.items.filter(item => item.variant_id === rule.gift && isGift(item));
      const have = lines.reduce((n, item) => n + item.quantity, 0);
      if (need === have) continue;
      try {
        if (!lines.length) {
          await post(drawer.dataset.addUrl, {items:[{id:rule.gift, quantity:need, properties:{_gift:'Free with your pack'}}]});
        } else {
          await post(drawer.dataset.changeUrl, {id:lines[0].key, quantity:need});
          for (const extra of lines.slice(1)) await post(drawer.dataset.changeUrl, {id:extra.key, quantity:0});
        }
        changed = true;
      } catch (_) {}
    }
    return changed;
  };

  const upgrade = async job => {
    const [cart, product] = await Promise.all([
      getJSON(drawer.dataset.cartUrl + '.js'),
      getJSON(job.productUrl + '.js')
    ]);
    const items = cart.items.filter(item => !isGift(item));
    const source = items.find(item => item.key === job.key);
    const target = product.variants.find(variant => String(variant.id) === job.variant);
    const strapLines = items.filter(item => String(item.product_id) === job.product);
    const coveredProducts = new Set(job.excludes.split(',').filter(Boolean));
    if (!source || source.quantity !== 1 || String(source.variant_id) !== job.from || strapLines.length !== 1 ||
        (cart.cart_level_discount_applications || []).length || source.selling_plan_allocation || Object.keys(source.properties || {}).length ||
        !target?.available || target.price - source.original_price !== job.delta || job.delta <= 0 ||
        items.some(item => String(item.variant_id) === job.variant || coveredProducts.has(String(item.product_id)))) {
      throw new Error(drawer.dataset.upgradeChanged);
    }
    const result = await post(drawer.dataset.updateUrl, {
      updates:{[job.key]:0, [job.variant]:1},
      ...sectionData()
    });
    if (result.items.some(item => item.key === job.key) ||
        !result.items.some(item => String(item.variant_id) === job.variant && item.quantity === 1)) {
      throw new Error(drawer.dataset.error);
    }
    return result;
  };
  const drain = async () => {
    if (busy) return;
    busy = true;
    setControls();
    while (queue.length) {
      const job = queue.shift();
      error('');
      const clearPending = () => {
        if (job.type === 'quantity' && !queue.some(next => next.type === 'quantity' && next.key === job.key)) pendingQuantities.delete(job.key);
      };
      try {
        const result = job.type === 'upgrade' ? await upgrade(job) :
          await post(job.url, job.body || {id:job.key, quantity:job.quantity, ...sectionData()});
        clearPending();
        if (job.type === 'add') track('add_to_cart_confirmed');
        const giftsChanged = await syncGifts(job.type === 'add' ? null : (result.items ? result : null));
        const html = giftsChanged ? null : result.sections?.[drawer.dataset.sectionId];
        if (html) render(html); else await refresh();
        if (job.open) open();
      } catch (e) {
        clearPending();
        try { await refresh(); } catch (_) {}
        error(e.message === drawer.dataset.upgradeChanged ? drawer.dataset.upgradeChanged : drawer.dataset.error);
        if (job.open) open();
      } finally {
        job.release?.();
      }
    }
    busy = false;
    setControls();
  };
  const enqueue = job => {
    queue.push(job);
    drain();
  };
  const changeQuantity = (key, quantity) => {
    pendingQuantities.set(key, quantity);
    document.querySelectorAll('[data-rv-quantity]').forEach(input => {
      if (input.dataset.key === key) input.value = quantity;
    });
    const queued = queue.find(job => job.type === 'quantity' && job.key === key);
    if (queued) queued.quantity = quantity;
    else enqueue({type:'quantity', url:drawer.dataset.changeUrl, key, quantity, open:false});
    setControls();
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const url = new URL(form.action, location.origin);
    if (url.origin !== location.origin) return;
    if (url.pathname === drawer.dataset.cartUrl && busy) {
      event.preventDefault();
      return;
    }
    if (url.pathname !== drawer.dataset.addUrl) return;
    event.preventDefault();
    if (form.dataset.rvPending || !form.checkValidity() || event.submitter?.disabled) return;
    const data = new FormData(form);
    if (!data.get('id')) return;
    data.set('sections', drawer.dataset.sectionId);
    data.set('sections_url', drawer.dataset.cartUrl);
    let body = data;
    const buy = form.closest('[data-tks-buy]');
    if (buy) {
      const main = {id:Number(data.get('id')), quantity:Number(data.get('quantity') || 1)};
      if (data.get('selling_plan')) main.selling_plan = data.get('selling_plan');
      const properties = {};
      for (const [key, value] of data) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = value;
      }
      if (Object.keys(properties).length) main.properties = properties;
      const addons = Array.from(buy.querySelectorAll('[data-tks-addon]:not([hidden]) [data-tks-addon-check]:checked'))
        .filter(input => !input.disabled)
        .map(input => ({id:Number(input.closest('[data-tks-addon]').dataset.variant), quantity:1}));
      body = {items:[main, ...addons], ...sectionData()};
    }
    const states = Array.from(form.elements).map(el => [el, el.disabled]);
    form.dataset.rvPending = 'true';
    form.setAttribute('aria-busy', 'true');
    states.forEach(([el]) => { el.disabled = true; });
    enqueue({
      type:'add', url:drawer.dataset.addUrl, body,
      open:!form.closest('[data-rv-page-content]'),
      release:() => {
        states.forEach(([el, disabled]) => { el.disabled = disabled; });
        delete form.dataset.rvPending;
        form.removeAttribute('aria-busy');
      }
    });
  });
  document.addEventListener('click', async event => {
    const checkout = event.target.closest('button[name="checkout"]');
    if (checkout?.form && !checkout.disabled) {
      const url = new URL(checkout.form.action, location.origin);
      if (url.origin === location.origin && url.pathname === drawer.dataset.cartUrl) track('checkout_button_clicked');
    }
    const close = event.target.closest('[data-rv-close]');
    if (close) { drawer.close(); return; }
    if (event.target === drawer) {
      const rect = drawer.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right) drawer.close();
      return;
    }
    if (event.target.closest('.wss-hd__cart')) {
      event.preventDefault();
      open();
      if (!busy) { try { await refresh(); } catch (_) { error(drawer.dataset.error); } }
      return;
    }
    const step = event.target.closest('[data-rv-step]');
    if (step && !step.disabled) {
      const input = step.parentElement.querySelector('[data-rv-quantity]');
      input.value = Math.max(0, Number(input.value) + Number(step.dataset.rvStep));
      input.dispatchEvent(new Event('change', {bubbles:true}));
      return;
    }
    const remove = event.target.closest('[data-rv-remove]');
    if (remove) {
      event.preventDefault();
      changeQuantity(remove.dataset.key, 0);
      return;
    }
    const button = event.target.closest('[data-rv-upgrade]');
    if (button && !button.disabled) {
      event.preventDefault();
      enqueue({
        type:'upgrade', open:false, key:button.dataset.key, from:button.dataset.from,
        variant:button.dataset.variant, delta:Number(button.dataset.delta),
        product:button.dataset.product, productUrl:button.dataset.productUrl, excludes:button.dataset.excludes || ''
      });
    }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-rv-quantity]')) return;
    const input = event.target;
    if (!input.checkValidity()) { input.reportValidity(); return; }
    changeQuantity(input.dataset.key, Number(input.value));
  });
  setControls();
  document.dispatchEvent(new CustomEvent('revene:cart-ready'));
  updateTimers();
  setInterval(updateTimers, 1000);
  /* Heal carts that were built before the gift lines existed (or edited elsewhere). */
  if (!busy) syncGifts().then(changed => { if (changed && !busy) return refresh(); }).catch(() => {});
  window.addEventListener('pageshow', event => { if (event.persisted && !busy) refresh().catch(() => {}); });
})();

  } catch(e) { console.error(e); }
})();
})();
